module.exports = __webpack_public_path__ + "static/img/rules-mobile.4be10cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rules-mobile.png
// module id = gweS
// module chunks = 1